import { NAMESPACE } from '../../lib/constants';
export const getExperiments = (state) => (state[NAMESPACE] && state[NAMESPACE].experiments) || {};
export const getExperiment = (state, projectId) => {
    return getExperiments(state)[projectId] || null;
};
export const isExperimentReady = (state, projectId) => {
    return typeof getExperiments(state)[projectId] !== 'undefined';
};
//# sourceMappingURL=selectors.js.map